function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6 15.1002V18.1002H8.9L14.8 12.2002L11.8 9.2002L6 15.1002ZM13.2 12.2002L8.5 16.9002H7.2V15.5002L11.8 10.8002L13.2 12.2002Z",
  fill: "#00AAFF"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.1008 6L12.8008 8.3L15.8008 11.3L18.1008 8.9L15.1008 6ZM15.7008 9.6L14.5008 8.3L15.1008 7.7L16.4008 9L15.7008 9.6Z",
  fill: "#00AAFF"
});
const SvgEditVersionIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEditVersionIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/editVersion_icon.841380bd.svg";
export { ForwardRef as ReactComponent };